import { AnimatePresence, motion } from 'motion/react';
import { useEffect } from 'react';
import { useUI } from '@/lib/store';

export function Toast() {
  const toast = useUI((s) => s.toast);
  const dismiss = useUI((s) => s.dismissToast);

  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(dismiss, toast.tone === 'celebrate' ? 5_000 : 3_500);
    return () => window.clearTimeout(t);
  }, [toast, dismiss]);

  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          key={toast.id}
          initial={{ opacity: 0, y: -16, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -16, scale: 0.95 }}
          transition={{ type: 'spring', stiffness: 300, damping: 26 }}
          className={`toast toast--${toast.tone}`}
          onClick={dismiss}
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          {toast.message}
          <style>{toastCss}</style>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

const toastCss = `
.toast {
  position: fixed; top: calc(var(--safe-top) + var(--space-5));
  left: 50%; transform: translateX(-50%);
  z-index: 50;
  padding: 12px 18px;
  border-radius: var(--r-pill);
  background: var(--c-paper);
  border: 1px solid var(--c-border);
  box-shadow: var(--shadow-md);
  font-size: var(--t-small);
  color: var(--c-ink);
  cursor: pointer;
  max-width: 90vw;
}
.toast--soft      { background: var(--c-paper); }
.toast--celebrate { background: var(--c-blush); border-color: var(--c-rose); }
.toast--warn      { background: #FFF1C7; }
`;
